import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { isSentryEnabled } from './app/is-sentry-enabled';
import { registerLicense } from '@syncfusion/ej2-base';
import * as Sentry from '@sentry/angular';
import 'zone.js';
import { platformBrowser } from '@angular/platform-browser';
import './app/d3-transition-setup';

registerLicense(environment.syncfusionLicenseKey);

if (isSentryEnabled()) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    release: environment.VERSION,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err: unknown) => {
    if (isSentryEnabled()) {
      Sentry.captureException(err);
    }
    console.error(err);
  });
